export const forceHashScroll = () => {
  const hash = window.location.hash;

  if (!hash) return;

  window.location.hash = '';

  setTimeout(() => {
    window.location.hash = hash;
  }, 0);
};
